import { Button } from 'cdhs-ui-library';
import { BsEnvelopeFill } from 'react-icons/bs';
import { useTranslations } from '../../contexts/LanguageContext';
interface IContactUs {
    onClick: ()=> void,
    option?: string,
    variant?: "NYTD"| "primary"| "secondary",
    mode?: "dark"|"light"
}
function ContactUsButton({onClick, option, variant= "NYTD", mode ="light"}: IContactUs) {
    const t = useTranslations()
  return (
                  <Button
                caption={t('completedSurvey_button', 'Contact us')}
                option={option}
                variant={variant}
                mode={mode}
                size="medium"
                fullWidth={true}
                iconPosition="Left"
                image={<BsEnvelopeFill />}
                onClick={onClick}
              />
  )
}

export default ContactUsButton